import PageLayout from '@/components/feature/PageLayout';
import { movies } from '@/mocks/movies';
import { news } from '@/mocks/news';
import HeroCarousel from './components/HeroCarousel';
import CategoryQuickNav from './components/CategoryQuickNav';
import HotMovies from './components/HotMovies';
import LatestNews from './components/LatestNews';
import SiteIntro from './components/SiteIntro';

export default function Home() {
  const featured = movies.filter((movie) => movie.featured);

  return (
    <PageLayout>
      <HeroCarousel movies={featured} />
      <CategoryQuickNav />
      <HotMovies movies={movies} />
      <LatestNews news={news} />
      <SiteIntro />
    </PageLayout>
  );
}